/** The five actions a role can hold on a catalog row (th_saas CU-91.4). */
export const PERMISSION_ACTIONS = ['Read', 'Write', 'Edit', 'Delete', 'Approve'] as const

export type PermissionAction = (typeof PERMISSION_ACTIONS)[number]

/** One row of a role's matrix: the actions it holds on a catalog key. */
export interface RoleModule {
  Key: string
  Read: boolean
  Write: boolean
  Edit: boolean
  Delete: boolean
  Approve: boolean
}

/** One row of `GET api/roles/catalog`: each flag means "can be granted on this row". */
export interface RoleCatalogRow {
  Key: string
  Group: string
  Label: string
  Read: boolean
  Write: boolean
  Edit: boolean
  Delete: boolean
  Approve: boolean
}

export interface Role {
  Id: number
  Name: string
  IsPreset: boolean
  CanApprove: boolean
  /** Active users holding the role. */
  UserCount: number
  /** Only the rows with at least one action. */
  Modules: RoleModule[]
}

/** Body of `POST api/roles`, `PUT api/roles/{id}` and `POST api/roles/validate`. Never carries `Allowances`. */
export interface RolePayload {
  Name: string
  Modules: RoleModule[]
}
